/**
 *
 */
export enum DrawingActionType {
  FETCH_DRAWING_DETAILS_START = "FETCH_DRAWING_DETAILS_START",
  FETCH_DRAWING_DETAILS_SUCCESS = "FETCH_DRAWING_DETAILS_SUCCESS",
  FETCH_DRAWING_DETAILS_FAIL = "FETCH_DRAWING_DETAILS_FAIL",

  FETCH_DRAWING_COORDINATES_START = "FETCH_DRAWING_COORDINATES_START",
  FETCH_DRAWING_COORDINATES_SUCCESS = "FETCH_DRAWING_COORDINATES_SUCCESS",
  FETCH_DRAWING_COORDINATES_FAIL = "FETCH_DRAWING_COORDINATES_FAIL",

  FETCH_DRAWING_PART_INFORMATION_START = "FETCH_DRAWING_PART_INFORMATION_START",
  FETCH_DRAWING_PART_INFORMATION_SUCCESS = "FETCH_DRAWING_PART_INFORMATION_SUCCESS",
  FETCH_DRAWING_PART_INFORMATION_FAIL = "FETCH_DRAWING_PART_INFORMATION_FAIL",

  UPDATE_DRAWING_MACHINE_SUCCESS = "UPDATE_DRAWING_MACHINE_SUCCESS",
  UPDATE_DRAWING_MACHINE_FAIL = "UPDATE_DRAWING_MACHINE_FAIL",

  UPDATE_DRAWING_STORE_STATE = "UPDATE_DRAWING_STORE_STATE",
  RESET_DRAWING_STORE_STATE = "RESET_DRAWING_STORE_STATE",

  SET_SELECTED_DRAWING_PART = "SET_SELECTED_DRAWING_PART",

  FETCH_DRAWING_IMAGE_BY_NAME_START = "FETCH_DRAWING_IMAGE_BY_NAME_START",
  FETCH_DRAWING_IMAGE_BY_NAME_SUCCESS = "FETCH_DRAWING_IMAGE_BY_NAME_SUCCESS",
  FETCH_DRAWING_IMAGE_BY_NAME_FAIL = "FETCH_DRAWING_IMAGE_BY_NAME_FAIL"
}
